// import dummyState from "App/common/dummies/default_settings";
import initState from "./initState";

import * as types from "./types";
import { updateObject, deepClone } from "utils";

function createEnums(enums, propKey) {
  const temp = { props: {} };

  for (let key in enums[propKey]) {
    temp[key] = enums[propKey][key];

    // TODO: remove name
    temp.props[enums[propKey][key]] = {
      key: key,
      name: key.toLowerCase()
    };

    // Backup Client Status
    if (propKey === "BackupScheduleStatus") {
      switch (key) {
        case "IN_PROGRESS":
          temp.props[enums[propKey][key]].class = "backup";
          break;
        case "CANCELLED":
        case "SUCCESS":
        case "PAUSED":
          temp.props[enums[propKey][key]].class = "safe";
          break;
        case "FAILURE":
          temp.props[enums[propKey][key]].class = "error";
          break;
        default:
          break;
      }
    }

    // Weekdays
    if (propKey === "WeekDays") {
      const subString = temp.props[enums[propKey][key]].name.substring(0, 3);

      temp.props[enums[propKey][key]].name =
        subString[0].toUpperCase() + subString.slice(1).toLowerCase();
      temp.props[enums[propKey][key]].code = enums[propKey][key];
      if (key === "SUNDAY") temp.props[enums[propKey][key]].priority = 2;
      else temp.props[enums[propKey][key]].priority = 1;
    }
  }

  return temp;
}

function fetchAppSettingsSuccess(state, action) {
  // Populate ENUMS
  const enumsObj = { ...state.enums };
  const virtualizationEnumsObj = { ...state.enums };
  const enums = { ...action.settings.enums };
  const virtualizationEnums = { ...action.settings.virtualization };

  for (let propKey in enums) {
    enumsObj[propKey] = createEnums(enums, propKey);
  }

  for (let propKey in virtualizationEnums) {
    virtualizationEnumsObj[propKey] = createEnums(virtualizationEnums, propKey);
  }

  return updateObject(state, {
    enums: enumsObj,
    virtualizationEnums: virtualizationEnumsObj
  });
}

function cacheBackupSettings(state, action) {
  return updateObject(state, {
    backupSettings: updateObject(state.backupSettings, action.settings)
  });
}

function cleanCache(state, action) {
  return updateObject(state, {
    [action.key]: null
  });
}

function showNotification(state, action) {
  return updateObject(state, {
    notification: updateObject(state.notification, {
      [action.alertName]: action.params
    })
  });
}

function hideNotification(state, action) {
  return updateObject(state, {
    notification: updateObject(state.notification, {
      [action.alertName]: null
    })
  });
}

function fetchAllPlansStart(state, action) {
  return updateObject(state, {
    plans: {
      loading: true
    }
  });
}

function fetchAllPlansSuccess(state, action) {
  return updateObject(state, {
    plans: updateObject(state.plans, {
      loading: false,
      data: action.data
    })
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.FETCH_APP_SETTINGS_SUCCESS:
      return fetchAppSettingsSuccess(state, action);
    case types.CACHE_BACKUP_SETTINGS:
      return cacheBackupSettings(state, action);
    case types.CLEAN_CACHE:
      return cleanCache(state, action);
    case types.SHOW_NOTIFICATION:
      return showNotification(state, action);
    case types.HIDE_NOTIFICATION:
      return hideNotification(state, action);
    case types.FETCH_ALL_PLANS_START:
      return fetchAllPlansStart(state, action);
    case types.FETCH_ALL_PLANS_SUCCESS:
      return fetchAllPlansSuccess(state, action);
    default:
      return state;
  }
}

export default reducer;
